export default "__VITE_ASSET__Sg2AcNgT__"